import './Footer.scss';
import { useNavigate } from 'react-router-dom';
import { format } from 'date-fns';
import Logo from '../../assets/Logo.png';
import Img1 from './img1.png';
import Img2 from './img2.png';
import { useEffect } from 'react';
import Sert from '../../assets/sert.png';

const Footer = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [window.location.pathname]);

  return (
    <div className='footer'>
      <div className='footer-content'>
        <div className='footer-content-logo'>
          <img src={Logo} />
        </div>
        <div className='footer-content-nav'>
          <div className='footer-content-nav-col'>
            <span className='footer-content-nav-link' onClick={() => navigate('/interim_leadership')}>
              Interim Leadership
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/executive_leadership')}>
              Executive Leadership
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/critical_access')}>
              Critical Access, Rural & Community Hospitals
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/hospital_staffing')}>
              Hospital Staffing Services
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/mentorship')}>
              Mentorship & Management Consulting
            </span>
          </div>
          <div className='footer-content-nav-col'>
            <span className='footer-content-nav-link' onClick={() => navigate('/operational_assessment')}>
              Operational Assessment
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/survey_readiness')}>
              Survey Readiness
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/LTC_leadership')}>
              LTC Leadership
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/locum_tenens')}>
              Locum Tenens Staffing Solutions
            </span>
          </div>
          <div className='footer-content-nav-col'>
            <span className='footer-content-nav-link' onClick={() => navigate('/revenue_cycle_assessment')}>
              Revenue Cycle Assessment
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/revenue_cycle_solutions')}>
              Revenue Cycle Solutions
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/revenue_cycle_consulting')}>
              Revenue Cycle Consulting & Staffing
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/for_candidates')}>
              For Candidates
            </span>
            <span className='footer-content-nav-link' onClick={() => navigate('/about')}>
              About Us
            </span>
          </div>
        </div>
        <div className='footer-content-awards'>
          <span className='footer-content-awards-1'>
            <img src={Img1} />
          </span>
          <span className='footer-content-awards-2'>
            <img src={Img2} />
          </span>
        </div>
        <div className='footer-info-sert footer-info-sert-1'>
          <span className='footer-info-sert-img'>
            <img src={Sert} />
          </span>
          <div className='footer-info-sert-details'>
            <span className='footer-info-sert-title'>Certified by The Joint Commission</span>
            <a className='footer-info-sert-link' href='https://www.jointcommission.org/en/contact-us' target='_blank'>
              Report a concern
            </a>
            <a className='footer-info-sert-link' href='mailto:info@thehealthcarepeople.com'>
              Quality concern
            </a>
          </div>
        </div>
      </div>
      <div className='footer-info'>
        <div className='footer-info-block'>
          <span>© {format(new Date(), 'yyyy')} American Consultants - The Healthcare People. All rights reserved.</span>
          <div className='footer-policy'>
            <a
              href='https://app.termly.io/policy-viewer/policy.html?policyUUID=d94582df-8db3-4369-9a8a-e1e1f088c58d'
              target='_blank'
            >
              Privacy policy
            </a>
            <a
              href='https://app.termly.io/policy-viewer/policy.html?policyUUID=c39976da-bc93-427b-a511-25e33d082944'
              target='_blank'
            >
              Terms and conditions
            </a>
            <a href='#' class='termly-display-preferences' id='open-consent'>
              Consent Preferences
            </a>
          </div>
        </div>
        <div className='footer-info-sert footer-info-sert-2'>
          <span className='footer-info-sert-img'>
            <img src={Sert} />
          </span>
          <div className='footer-info-sert-details'>
            <span className='footer-info-sert-title'>Certified by The Joint Commission</span>
            <a className='footer-info-sert-link' href='https://www.jointcommission.org/en/contact-us' target='_blank'>
              Report a concern
            </a>
            <a className='footer-info-sert-link' href='mailto:info@thehealthcarepeople.com'>
              Quality concern
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Footer;
